/**
 * Pseudo-random QR code SVG — visually convincing for mockups; not a real
 * scannable code. Reserves corners for the finder patterns so it reads as
 * a QR even at thumbnail size.
 */
export default function QRCode({ size = 80 }) {
  const cells = 21;
  const cellSize = size / cells;
  const pattern = Array.from({ length: cells * cells }, (_, i) => {
    const r = Math.abs(Math.sin(i * 7.3 + 2.1)) * 1000;
    return r % 1 > 0.55;
  });
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ background: '#fff' }}>
      {pattern.map((on, i) => {
        if (!on) return null;
        const x = (i % cells) * cellSize;
        const y = Math.floor(i / cells) * cellSize;
        // Reserve corners for finder patterns
        if (
          (x < cellSize * 7 && y < cellSize * 7) ||
          (x > size - cellSize * 7 && y < cellSize * 7) ||
          (x < cellSize * 7 && y > size - cellSize * 7)
        ) return null;
        return <rect key={i} x={x} y={y} width={cellSize} height={cellSize} fill="var(--navy)" />;
      })}
      {[[0, 0], [cells - 7, 0], [0, cells - 7]].map(([fx, fy], i) => (
        <g key={i}>
          <rect x={fx * cellSize} y={fy * cellSize} width={cellSize * 7} height={cellSize * 7} fill="var(--navy)" />
          <rect x={(fx + 1) * cellSize} y={(fy + 1) * cellSize} width={cellSize * 5} height={cellSize * 5} fill="#fff" />
          <rect x={(fx + 2) * cellSize} y={(fy + 2) * cellSize} width={cellSize * 3} height={cellSize * 3} fill="var(--navy)" />
        </g>
      ))}
    </svg>
  );
}
